import {head} from 'ramda';

/** The make a purchase price rule narrows to, or `undefined` unless exactly one make is selected. */
export const getSinglePurchasePriceRuleMake = (makes: string[]) =>
  makes.length === 1 ? head(makes) : undefined;
